/*
 *  /user-bis 子帐户 接口
 */

import { Base } from "./base"


class UserService extends Base {
  constructor(opt) {
    super(opt)
  }


  // 删除自己的子帐户
  async rmUserBis(bisId) {
    return this.delete('/', { params: { bisId } })
  }

}

// 使用并导出类
export default new UserService({ prefix: '/v1/user-bis' })